import React from "react";
import styles from "../CustomReportsForm.module.sass";
import { Dropdown } from "colbi_web_ui/lib/components/inputs";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosIcon } from "mosaic-react";
import { HighlightOff } from "mosaic-react-icons";
const ConfigsTab = ({ Config, Classifiers, handleConfigsChange, handleChange }) => {
    const { i18n } = useGlobalValue();
    const { level, appliesTo } = Classifiers || {};

    const parsedConfig = JSON.parse(Config || "[]");

    const usedAppliesTo = (parsedConfig || []).map(({ FileType }) => FileType);
    const availableAppliesTo = (appliesTo || []).filter(
        ({ id }) => !(usedAppliesTo || []).includes(id),
    );

    const crConfigurations = buildConfigsDataContainer(parsedConfig);

    function buildConfigsDataContainer(CrConfigs) {
        const hasCRConfigs = !!(CrConfigs && CrConfigs.length);

        return (
            hasCRConfigs &&
            CrConfigs.map((elem, index) => {
                const { FileType, ReportExecutionLevel } = elem || {};

                return (
                    <div key={index} className={styles["cr-entry"]}>
                        <div className={styles["config-remove-button-container"]}>
                            <div className={styles["remove-button-container"]}>
                                <button
                                    type="button"
                                    className={styles["remove-button"]}
                                    onClick={(e) => {
                                        CrConfigs.splice(index, 1);
                                        handleChange(e, "Configs", JSON.stringify(CrConfigs));
                                    }}
                                >
                                    <SovosIcon>
                                        <HighlightOff />
                                    </SovosIcon>
                                </button>
                            </div>
                        </div>
                        <div className={styles["flex"]}>
                            <div className={styles["input-field"]}>
                                <h5 className={styles["label"]}>{i18n`Applies To`}</h5>
                                <Dropdown
                                    value={
                                        FileType && appliesTo.length
                                            ? appliesTo.find(({ id }) => id === FileType) ||
                                              appliesTo[0]
                                            : null
                                    }
                                    useI18n={false}
                                    options={availableAppliesTo || []}
                                    placeholder={""}
                                    className={styles["dropdown"]}
                                    filter
                                    onChange={(e) => {
                                        handleConfigsChange(
                                            e,
                                            "FileType",
                                            e.target.value.id,
                                            index,
                                            CrConfigs,
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className={styles["input-field"]}>
                            <h5 className={styles["label"]}>{i18n`Execute On`}</h5>
                            <Dropdown
                                value={
                                    ReportExecutionLevel && level.length
                                        ? level.find(({ id }) => id === ReportExecutionLevel)
                                        : null
                                }
                                placeholder={""}
                                options={level || []}
                                className={styles["dropdown"]}
                                required
                                filter
                                onChange={(e) => {
                                    handleConfigsChange(
                                        e,
                                        "ReportExecutionLevel",
                                        e.target.value.id,
                                        index,
                                        CrConfigs,
                                    );
                                }}
                            />
                        </div>
                    </div>
                );
            })
        );
    }

    function buildConfigsContainer(parsedConfig) {
        const defaultObj = {
            FileType: "",
            ReportExecutionLevel: "",
        };
        return (
            <div>
                <div className={styles["flex"]}>
                    <div className={styles["input-field"]}>
                        <div>
                            {(parsedConfig || []).length ? (
                                crConfigurations
                            ) : (
                                <small>{i18n`No configuration assigned`}</small>
                            )}
                        </div>
                        <div>
                            <button
                                className={styles["add-button"]}
                                type="button"
                                onClick={(e) => {
                                    handleChange(
                                        e,
                                        "Configs",
                                        JSON.stringify([
                                            ...(parsedConfig || []),
                                            { ...defaultObj },
                                        ]),
                                    );
                                }}
                            >
                                {<small>{i18n`[+] Add new Configuration`}</small>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className={styles["group-content"]}>{buildConfigsContainer(parsedConfig)}</div>
        </div>
    );
};

export default ConfigsTab;
